<template>
  <div class="flex flex-col flex-grow overflow-auto">
    <div class="flex flex-col items-center mt-2">
      <hr class="w-full" />
      <span
        class="flex items-center justify-center -mt-3 bg-white h-6 px-3 rounded-full border text-xs font-semibold mx-auto"
        >Bugün</span
      >
    </div>
    <div
      class="flex px-4 py-3 space-x-2 items-start"
      :key="result.id"
      v-for="result in results"
    >
      <div class="h-10 w-10 rounded flex-shrink-0 bg-gray-300"></div>
      <div class="ml-2">
        <div class="-mt-1">
          <span class="text-sm font-semibold">{{
            $root.getVal(15, result.insert_agent_id)
          }}</span>
          <span class="ml-1 text-xs text-gray-500">{{
            result.created_at
          }}</span>
        </div>
        <span class="text-sm">
          {{ result.body }}
        </span>
      </div>
      <a class="text-black" target="blank" :href="'/leadDetail/' + result.lead_id"
        ><svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-4 h-4"
          viewBox="0 0 24 24"
        >
          <path
            fill="currentColor"
            d="m12 23l-3-3H3V2h18v18h-6zm0-11q1.45 0 2.475-1.025T15.5 8.5q0-1.45-1.025-2.475T12 5q-1.45 0-2.475 1.025T8.5 8.5q0 1.45 1.025 2.475T12 12m-7 6h14v-1.15q-1.35-1.325-3.137-2.087T12 14q-2.075 0-3.863.763T5 16.85z"
          />
        </svg>
      </a>
    </div>
  </div>
</template>

<script>
import http from "../services/http";

export default {
  name: "list",
  data() {
    return {
      table: "lead_notes",
      permissionMap: [],
      tableInfo: {},
      results: [],
      page: 0,
      total: 0,
    };
  },
  props: ["limit", "channel"],
  computed: {
    permissionDetail() {
      return this.$root.cache.permissions.find((e) => e.table == this.table);
    },
  },
  methods: {
    nextPage() {
      this.page++;
      this.getData();
    },
    prevPage() {
      this.page--;
      this.getData();
    },
    getData() {
      http
        .chatMessages({
          table: this.table,
          page: this.page,
          sort: {
            type: "desc",
            name: "id",
          },
          limit: this.limit,
          filters: [
            {
              name: "note_status_id",
              value: 7,
              type: 1,
            },
            {
              name: "channel_id",
              value: this.channel,
              type: 1,
            },
          ],
        })
        .then((response) => {
          this.results = response.data.results;
          this.total = parseInt(response.data.total);
        });
    },
  },
  created() {
    this.getData();
  },
  mounted() {
    setInterval(() => {
      this.getData();
    }, 30000);
  },
};
</script>
